import type { SVGProps } from "react";

export default function CorporateFinIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.3335 18.333H1.66683"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M17.5001 18.3335V12.0835C17.5001 11.3932 16.9404 10.8335 16.2501 10.8335H13.7501C13.0598 10.8335 12.5001 11.3932 12.5001 12.0835V18.3335"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M12.5004 18.3332V4.1665C12.5004 2.988 12.5004 2.39874 12.1343 2.03262C11.7681 1.6665 11.1789 1.6665 10.0004 1.6665C8.82187 1.6665 8.2326 1.6665 7.86648 2.03262C7.50037 2.39874 7.50037 2.988 7.50037 4.1665V18.3332"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M7.50019 18.3337V7.91699C7.50019 7.22663 6.94055 6.66699 6.25019 6.66699H3.75019C3.05984 6.66699 2.50019 7.22663 2.50019 7.91699V18.3337"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
